module.exports = __webpack_public_path__ + "img/faq-1.59232d70.png";